module.exports = __webpack_public_path__ + "img/thumbnail_Axolotl_u_normal.53538c83.png";